import { makeStyles } from 'tss-react/mui';


export const psychDrawerWidth = 420;


export const useDrawerStyles = makeStyles({ name: 'LightLayoutRightDrawer' })(theme => ({
  appBarShift: {
    zIndex: theme.zIndex.drawer - 1,
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    flexShrink: 0,
    width: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerOpened: {
    width: `${psychDrawerWidth}px`,
  },
  paper: {
    width: `${psychDrawerWidth}px`,
  },
  backButton: {
    color: '#fff',
    marginRight: theme.spacing(3),
  }
}));
